(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-filtech-directflow"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('moqua-forte')){customElements.define('moqua-forte',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const success=this.querySelector('[data-forte-success]'),errors=this.querySelector('[data-forte-errors]');if(errors)errors.focus();if(success){success.focus();return;}const whirl=this.querySelector('[data-forte-whirl]'),install=this.querySelector('[data-forte-install]'),total=this.querySelector('[data-forte-total]'),summary=this.querySelector('[data-forte-summary]'),tap=this.querySelector('[data-forte-tap]'),tapLink=this.querySelector('[data-forte-taps]');if(!whirl||!install||!total||!summary)return;const money=n=>'CHF '+String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'’');const update=()=>{const price=2290+(whirl.checked?200:0)+(install.checked?450:0);total.textContent=money(price);summary.value='MOQUA FORTE: '+money(price)+' inkl. MwSt.; Alvito: '+(whirl.checked?'ja':'nein')+'; Standardmontage angefragt: '+(install.checked?'ja':'nein')+'. Armatur, Versand und allfällige Zusatzarbeiten separat.';if(tapLink){const url=new URL(tapLink.href,window.location.origin);url.searchParams.set('system','forte');[['whirl',whirl.checked],['install',install.checked]].forEach(([key,selected])=>{if(selected)url.searchParams.set(key,'1');else url.searchParams.delete(key);});tapLink.href=url.href;}};whirl.addEventListener('change',update);install.addEventListener('change',update);if(tap)tap.addEventListener('change',update);update();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-inquiry"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('moqua-inquiry')){customElements.define('moqua-inquiry',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const key='moqua:contact:pending:v1',success=this.querySelector('[data-contact-success]'),errors=this.querySelector('[data-contact-errors]');if(errors){errors.focus();try{sessionStorage.removeItem(key);}catch{}}if(success){success.focus();try{const p=JSON.parse(sessionStorage.getItem(key)||'null');sessionStorage.removeItem(key);if(p&&Number.isFinite(p.created)&&Date.now()-p.created>=0&&Date.now()-p.created<1800000&&['kitchen','house','spares','service','camping','refinement','unsure'].includes(p.topic)&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true&&typeof window.Shopify?.analytics?.publish==='function'){Promise.resolve(window.Shopify.analytics.publish('moqua:contact_success',{form:'moqua_beratung',topic:p.topic})).catch(()=>{});}}catch{}return;}const form=this.querySelector('form'),topic=this.querySelector('[data-field="topic"]'),selection=this.querySelector('[data-field="selection"]'),panel=this.querySelector('[data-selection]'),kitchen=this.querySelector('[data-kitchen-details]'),kitchenFields=this.querySelector('[data-kitchen-fields]');if(!form||!topic||!selection)return;let selectionTopic='';const params=new URLSearchParams(location.search),requested=params.get('topic'),choiceKey=params.get('choice');const label=selector=>this.querySelector(selector)?.content.textContent.trim()||'';const clear=()=>{selection.value='';selection.disabled=true;panel.hidden=true;selectionTopic='';};const update=()=>{const value=topic.selectedOptions[0]?.dataset.topicKey;kitchen.hidden=value!=='kitchen';kitchenFields.disabled=value!=='kitchen';if(selectionTopic&&selectionTopic!==value)clear();};const option=Array.from(topic.options).find(o=>o.dataset.topicKey===requested);if(option){topic.value=option.value;const choice=Array.from(this.querySelectorAll('[data-inquiry-choice]')).find(t=>t.dataset.inquiryChoice===choiceKey&&t.dataset.topic===requested);if(choice){selection.value=choice.content.textContent.trim();selectionTopic=requested;selection.disabled=false;panel.hidden=false;const qty=params.get('qty')==='2'?2:1,isNussbaum=['spares_nussbaum_short','spares_nussbaum_long'].includes(choiceKey),isJrg=choiceKey==='spares_jrg';if(requested==='spares'&&(isNussbaum||isJrg)){selection.value+='\n'+label('[data-inquiry-quantity]')+' '+qty;const extras=isNussbaum?['key','ring','em','stones']:['key','em','stones'];extras.forEach(extra=>{if(params.get(extra)==='1')selection.value+='\n'+label(isJrg&&extra==='key'?'[data-inquiry-jrg-key]':'[data-inquiry-extra="'+extra+'"]');});const cents=isNussbaum?(choiceKey==='spares_nussbaum_long'?8050:5150)*qty+(params.get('key')==='1'?3500:0)+(params.get('ring')==='1'?1750:0):5900*qty+(params.get('key')==='1'?2500:0);selection.value+='\n'+label('[data-inquiry-total-label]')+' CHF '+(cents/100).toFixed(2);}if(requested==='kitchen'&&params.get('system')==='forte'&&choiceKey.startsWith('kitchen_tap_')){const whirl=params.get('whirl')==='1',install=params.get('install')==='1',price=2290+(whirl?200:0)+(install?450:0);selection.value=label('[data-inquiry-forte-context]')+'\n'+selection.value;if(whirl)selection.value+='\n'+label('[data-inquiry-forte-whirl]');if(install)selection.value+='\n'+label('[data-inquiry-forte-install]');selection.value+='\n'+label('[data-inquiry-forte-total]')+' CHF '+String(price).replace(/\B(?=(\d{3})+(?!\d))/g,'’')+'\n'+label('[data-inquiry-forte-scope]');}if(params.get('extras')==='1')selection.value+='\n'+label('[data-inquiry-refinement]');}}update();topic.addEventListener('change',update);this.querySelector('[data-clear-selection]').addEventListener('click',()=>{clear();topic.focus();});form.addEventListener('submit',()=>{if(!form.checkValidity())return;try{sessionStorage.setItem(key,JSON.stringify({created:Date.now(),topic:topic.selectedOptions[0]?.dataset.topicKey||'unsure'}));}catch{}});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;document.querySelectorAll('.mq-nav2 details[open]').forEach(function(d){d.open=false;d.querySelector('summary').focus();});});document.addEventListener('click',function(e){document.querySelectorAll('.mq-nav2 details[open]').forEach(function(d){if(!d.contains(e.target)||e.target.closest('a'))d.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-taps"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('moqua-taps')){customElements.define('moqua-taps',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;const params=new URLSearchParams(window.location.search);if(params.get('system')==='forte'){this.querySelectorAll('[data-tap-inquiry]').forEach(link=>{const url=new URL(link.href,window.location.origin);if(url.origin!==window.location.origin||url.searchParams.get('topic')!=='kitchen'||!url.searchParams.get('choice')?.startsWith('kitchen_tap_'))return;url.searchParams.set('system','forte');['whirl','install'].forEach(key=>{if(params.get(key)==='1')url.searchParams.set(key,'1');else url.searchParams.delete(key);});link.href=url.href;});}this.addEventListener('click',event=>{const button=event.target.closest('[data-tap-filter]');if(!button)return;const selected=button.dataset.tapFilter;this.querySelectorAll('[data-tap-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;this.querySelectorAll('[data-tap-group]').forEach(item=>{const show=selected==='all'||item.dataset.tapGroup===selected;item.hidden=!show;if(show)count++;});this.querySelector('[data-tap-count]').textContent=count;});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-water-advisor"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialise(root) {
    if (root.dataset.advisorReady) return;
    root.dataset.advisorReady = 'true';
    var form = root.querySelector('[data-advisor-form]');
    var panel = root.querySelector('[data-result-panel]');
    var error = root.querySelector('[data-error]');
    function clearResult() {
      panel.hidden = true;
      panel.replaceChildren();
      error.hidden = true;
    }
    form.addEventListener('change', function (event) {
      clearResult();
      if (event.target.name.indexOf('location-') !== 0) return;
      root.querySelectorAll('[data-goals]').forEach(function (fieldset) {
        var active = fieldset.dataset.goals === event.target.value;
        fieldset.hidden = !active;
        fieldset.disabled = !active;
        fieldset.querySelectorAll('input').forEach(function (input) { input.checked = false; });
      });
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var active = form.querySelector('[data-goals]:not([disabled])');
      var goal = active && active.querySelector('input:checked');
      if (!goal) {
        error.hidden = false;
        var first = active ? active.querySelector('input') : form.querySelector('input[type="radio"]');
        if (first) first.focus();
        return;
      }
      var result = root.querySelector('template[data-result="' + goal.value + '"]');
      if (!result) return;
      panel.replaceChildren(result.content.cloneNode(true));
      var refinement = form.querySelector('[data-refinement]').checked;
      var inquiry = panel.querySelector('[data-advisor-inquiry]');
      var url = new URL(inquiry.href, window.location.origin);
      url.searchParams.set('topic', active.dataset.goals);
      url.searchParams.set('choice', goal.value);
      if (refinement) url.searchParams.set('extras', '1');
      inquiry.href = url.href;
      if (refinement) panel.appendChild(root.querySelector('[data-extra-result]').firstElementChild.cloneNode(true));
      error.hidden = true;
      panel.hidden = false;
      panel.focus({ preventScroll: true });
      panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    });
    root.querySelector('[data-reset]').addEventListener('click', function () {
      form.reset();
      clearResult();
      root.querySelectorAll('[data-goals]').forEach(function (fieldset) { fieldset.hidden = true; fieldset.disabled = true; });
      form.querySelector('input[type="radio"]').focus();
    });
  }
  document.querySelectorAll('[data-moqua-advisor]').forEach(initialise);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-moqua-advisor]').forEach(initialise); });
})();

  } catch(e) { console.error(e); }
})();
})();
